import { JSX, StrictMode } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ServerSideSettingsCollection } from '../../Shared/Base/server-side-settings-collection';
import PrivateCustomer from '.';
import MyInformation from './components/MyInformation';
import MyOffers from './components/MyOffers';
import MyTickets from './components/MyTickets';
import Welcome from './components/Welcome';

export interface IPrivateCustomerSettings extends ServerSideSettingsCollection {
  basename: string;
}

export default function createMittKontoPrivateCustomerRouterProvider(settings: IPrivateCustomerSettings): JSX.Element {
  const router = createBrowserRouter(
    [
      {
        path: '/',
        element: <PrivateCustomer />,
        children: [
          { index: true, element: <MyTickets /> },
          { path: 'mina-uppgifter', element: <MyInformation /> },
          { path: 'mina-erbjudanden', element: <MyOffers /> },
          { path: 'mina-biljetter', element: <MyTickets /> },
          { path: 'valkommen', element: <Welcome /> },
        ],
      },
    ],
    { basename: settings.basename },
  );

  return (
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>
  );
}
